
import axios from 'axios'


const Asset = {

  async get(collectionId,proofGroupId){
        const options = {
            url: `${window.ProveAnything.config.functionPath}/collection/get/${collectionId}/proofGroup/${proofGroupId}/asset`,
            baseURL: window.ProveAnything.config.functionUrl,
            method: "get",
            headers: {
              "Content-Type": "application/json"
            },
            responseType: "json",
          };
      
          try {
            const response = await axios(options);
            const json = response.data;
      
            return json;
          } catch (error) {
            return error
          }
    },
    async getDefault(collectionId,proofGroupId){
      const options = {
          url: `${window.ProveAnything.config.functionPath}/collection/get/${collectionId}/proofGroup/${proofGroupId}/asset/default`,
          baseURL: window.ProveAnything.config.functionUrl,
          method: "get",
          headers: {
            "Content-Type": "application/json"
          },
          responseType: "json",
        };
    
        try {
          const response = await axios(options);
          const json = response.data;
    
          return json;
        } catch (error) {
          return error
        }
  }, 
  
  // uploads a file - you must either be authorised as the owner of the collection/proofGroup
  // or at elast be logged in again a personal account to save a file
  async uploadImage(collectionId, file, proofGroupId){

    var formData = new FormData();
    formData.append("file", file);
    formData.append("site", collectionId);
    if (proofGroupId)
      formData.append("proofGroup", proofGroupId);
    formData.append("folder", "images");


    const options = {
      url: `${window.ProveAnything.config.functionPath}/asset/saveFile`,
      baseURL: window.ProveAnything.config.functionUrl,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData,
      responseType: "json",
    };

    let upload = {}
    try {
      const response = await axios(options);
      upload = response.data;
      return upload
    } catch (error) {
      return error
    }

  },
  




}

export default Asset;
